import React from "react";
import SubPageLayout, { type SubPageContent } from "@/components/common/SubPageLayout";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
export default function CustomSinteredMeshPage() {
  const {
    lang
  } = useLanguage();
  const content: SubPageContent = pick(lang, COPY);
  return <SubPageLayout content={content} />;
}